import { useEffect } from 'react'

import Paper from '@mui/material/Paper'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

import { CLIENT } from 'services/utils'
import Sections from 'Components/Sections'
import Loading from 'Components/Loading'
import Title from 'Components/Title'
import config from '../../../static/Especialidade' 
import Back from 'Components/Back'

import { useHistory } from 'Components/useHistory'

import Modal from 'Components/Modal'
import useEspecialidades from 'hooks/useEspecialidades'

const input = {
    name: 'idEspecialidade',
    label: 'descricaoEspecialidade'
}

const Especialidade = () => {

    const { 
        onConfirm, 
        onBack, 
        onLoad, 
        selectItem, 
        data, 
        open, 
        loading 
    } = useEspecialidades()

    const { historyPaths } = useHistory()

    historyPaths.add('/especialidade')

    const Observation = () => {
        
        if (CLIENT !== 'UNICLINICA') return null

        return <Typography variant={'caption'} sx={{py: 2, fontWeight: 'bold'}}>
            *Os valores são apenas referências e podem ser alterados sem aviso prévio.
        </Typography>
    }

    const getPropsButton = ({isChildren, onClick}) => {
        const props = {
            component: Paper, 
            key: 'voltar',
            sx: {
                textAlign: 'center',
                height: 80,
                width: '100%',
                //lineHeight: '80px',
                whiteSpace: 'break-spaces',
                cursor: 'pointer',
                overflow: 'hidden',
                color: '#000',
                bgColor: '#ddd',
                
            },
        }

        const voltar = {
            
            name: 'redirect',
            elevation: 4,
            id: 'redirect',
            onClick: _ => onClick('voltar'),
            value: 'voltar',
            children: 'Voltar'
        } 

        const customProps = { ...props, ...voltar} 

        return isChildren ? <Button {...customProps} /> : null
    }

    const description = <>
        <div style={{margin: '3px 0'}}>Favor entrar em contato com a Central.</div>
    </>

    useEffect(() => {
        onLoad()
    }, [onLoad])

    return <>
        <Modal
            title='Central de Agendamento' 
            description={description}
            labelConfirm='Ok'
            handleConfirm={onConfirm}
            disableCancel={true}
            disableEscapeKeyDown={true}
            open={open} 
            hideImportant
        />
        <Title title={config[CLIENT].title} />
        <Sections
            items={data} 
            totalByPerPage={8} 
            selectItem={selectItem} 
            input={input}
            ButtonAction={getPropsButton}
            Obs={Observation}
        />
        <Back onClick={onBack} loading={loading} />
        {loading && <Loading />}
    </>
     
}

export default Especialidade